import {RequiredTaggingEditorBaseErrorsEnum} from '../../../../editors/requiredTaggingEditor/requiredTaggingEditorErrors';
import {RuleEditorErrorsEnum} from '../../ruleEditorErrors';

/*
 * Types.
 */

export const RequiredTaggingEditorErrorsEnum = {
  // TODO change when decoupled from rule editor
  ...RuleEditorErrorsEnum,
  ...RequiredTaggingEditorBaseErrorsEnum,
};

export type RequiredTaggingEditorErrorsEnum =
  // TODO change when decoupled from rule editor
  RuleEditorErrorsEnum | RequiredTaggingEditorBaseErrorsEnum;
